/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Customer_Delete_Dialog_Confirm_PrefixInputs */

const vi_customer_delete_dialog_confirm_prefix = /** @type {(inputs: Customer_Delete_Dialog_Confirm_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xoá khách hàng`)
};

/**

* @param {Customer_Delete_Dialog_Confirm_PrefixInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const customer_delete_dialog_confirm_prefix = /** @type {((inputs?: Customer_Delete_Dialog_Confirm_PrefixInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Customer_Delete_Dialog_Confirm_PrefixInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_customer_delete_dialog_confirm_prefix(inputs)
});